import { useEffect } from 'react'
import { captureReferralCode } from '../model/referralCookie'

export function ReferralCapture() {
  useEffect(() => {
    captureReferralCode(window.location.search)
  }, [])
  return null
}
